import * as types from "../../../_constants/types";

export default (state = ["CAEN", "CAFR"], action) => {
    switch (action.type) {
        case types.STORE_LOAD:
            return action.results;

        case types.RESET:
        case types.STORE_RESET:
            return ["CAEN", "CAFR"];

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/_reducers/Misc/Store/_store.js